import * as PropTypes from 'prop-types';
import React from 'react';
import _ from 'underscore';

import {FromServerProtocol} from 'notebook/ELNConstants';
import * as StepConstants from 'notebook/protocols/StepConstants';
// @ts-expect-error
import StepByStep from 'notebook/protocols/viewer/StepByStep';
import {FullTableMap} from 'notebook/tables/excess/Evaluator';
import withSpreadsheetEvaluation from 'notebook/tables/spreadsheets/withSpreadsheetEvaluation';

const WrappedStepByStep = withSpreadsheetEvaluation(StepByStep);

interface StepByStepContainerProps {
  closeStepByStep: () => void;
  protocol: FromServerProtocol;
}

export default class StepByStepContainer extends React.Component<StepByStepContainerProps> {
  static propTypes = {
    closeStepByStep: PropTypes.func.isRequired,
    protocol: PropTypes.object.isRequired,
  };

  makeFullTableMap = (props: StepByStepContainerProps): FullTableMap => {
    const tableSteps = _.where(this.spreadsheetRoot(props), {level: StepConstants.StepLevel.TABLE});
    const tableMap: FullTableMap = {};
    for (const step of Array.from(tableSteps)) {
      tableMap[step.table!.name] = step.table!;
    }
    return tableMap;
  };

  spreadsheetRoot = (props: StepByStepContainerProps): FromServerProtocol['steps'] => props.protocol.steps;

  selectorsFromProps = (props: StepByStepContainerProps): FromServerProtocol['selectors'] =>
    props.protocol.selectors;

  getNoteRuntimeSnapshot = (): null => /* TODO(BNCH-14712) */ null;

  render(): JSX.Element {
    return (
      <WrappedStepByStep
        {...this.props}
        makeFullTableMap={this.makeFullTableMap}
        selectorsFromProps={this.selectorsFromProps}
        spreadsheetRoot={this.spreadsheetRoot}
        getNoteRuntimeSnapshot={this.getNoteRuntimeSnapshot}
      />
    );
  }
}
